var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('UiModal',_vm._b({ref:"videoModal",attrs:{"rounded":false,"background":"transparent","height":"100%","close-button":"outside"},on:{"input":_setup.onChangeValue}},'UiModal',_vm.$attrs,false),[_c('UiVideo',{attrs:{"id":_vm.id,"container-size":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }